import { ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { TourApiService } from 'src/app/modules/tour/services/tour-api.service';
import { TourService } from 'src/app/modules/tour/services/tour.service';
import { AccountsService } from 'src/app/services/accounts.service';
import { CommonService } from 'src/app/services/common.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { LoginService } from 'src/app/services/login.service';
import { NotificationService } from 'src/app/services/notification.service';
import { WhatsNewService } from 'src/app/services/whats-new.service';
import { getPageSize, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { WhatappIntegrationPopupComponent } from 'src/app/whatapp-integration-popup/whatapp-integration-popup.component';
import { environment } from 'src/environments/environment';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'calsoft-header-user',
  templateUrl: './header-user.component.html',
  styleUrls: ['./header-user.component.scss']
})
export class HeaderUserComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();


  unreadNotifications = 5;
  twoFactorEnabled: boolean | null = null;
  notificationList: any;
  isOpen: boolean;
  @ViewChild('notificationTrigger') notificationTrigger: MatMenuTrigger;
  showWhatsNew: boolean = false;
  isSearchingWhatsNew: boolean = false;
  whatsNewSearchQuery: string = '';
  whatsNewData: any[] = [];
  enableAddUser: boolean = false;
  username: any;
  adminHeader: any;
  accountList: any = [];

  displayRenewButton: any = false;

  text: string = 'Add New User';

  showadduser: boolean = false;

  read: any = false;

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'notificationId' + "," + Constant.Dsc;
  unreadCount = 0;
  role: any;

  pageList: any;
  elements: any;
  pageSizeValue: number[];

  selectedFilter: string = 'all';
  loading: boolean = false;
  isLastPage: boolean = false;

  user: any = {
    name: '',
    role: '',
    avatar: 'assets/images/avatars/avatar.jpg', // Placeholder
    status: 'online'
  };


  public serverPath = environment.stepGuideImage + '/whatsNew/';
  posEnabled: any = 0;


  constructor(
    public router: Router,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private _changeDetectorRef: ChangeDetectorRef,
    private accountService: AccountsService,
    private snackBar: MatSnackBar,
    private loginService: LoginService,
    private ecryptService: EcryptServiceService,
    private tourService: TourService,
    private whatsNewService: WhatsNewService,
    private dialog: MatDialog,
    private readonly tourApi: TourApiService,
    private subscriptionsService: SubscriptionsService,
    private configService: ConfigService,
  ) { }

  tourEnabled: boolean = false;
  tourLoading$ = this.tourService.loading$;

  trialExpiredMessage: any;

  ngOnInit(): void {

    this.loginService.authenticatedUserSubject
      .pipe(takeUntil(this._destroy$))
      .subscribe(username => {
        this.username = username;
        this.user.name = username;
        this._changeDetectorRef.detectChanges();
      });

    this.adminHeader = localStorage.getItem("adminHeader");

    this.role = localStorage.getItem("VST");

    this.user.role = this.role;

    this.getAllNotification();

    this.getAccountData();

    this.getConfigData();


    const trialExpired = localStorage.getItem('trialExpiredMessage');
    this.trialExpiredMessage = this.safeDecryptAndParse(trialExpired);

    this.subscriptionsService.trialExpiredMessage$
      .pipe(takeUntil(this._destroy$))
      .subscribe(msg => {
        this.trialExpiredMessage = msg;
        this._changeDetectorRef.detectChanges();
      });


    let userType: any | null = null;

    const encryptedUserSettings = localStorage.getItem('userSettingsData');

    if (encryptedUserSettings) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
        const userSettings = JSON.parse(decrypted);
        userType = userSettings.userType;
      } catch (error) {
        console.error('Error decrypting or parsing userSettingsData:', error);
      }
    }

    if (!userType) {
      const encryptedSigninDetails = localStorage.getItem('signinDetails');
      if (encryptedSigninDetails) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
          const signinDetails = JSON.parse(decrypted);
          userType = signinDetails.userType;
          if (typeof signinDetails.twoFactorEnabled === 'boolean') {
            this.twoFactorEnabled = signinDetails.twoFactorEnabled;
          }
        } catch (error) {
          console.error('Error decrypting or parsing signinDetails:', error);
        }
      }
    }

    this.loadTwoFactorStatus();
    this.loadWhatsNew();
  }

  getConfigData() {
    this.configService.getConfigDataNew()
      .subscribe(
        (response: any) => {


          let configData = response;

          let config = response;

          if (response.encryptedText != null) {
            const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
            configData = JSON.parse(decrypted);
          }

          if (configData != null) {
            this.posEnabled = configData['posEnabled'];
          } else {
            this.posEnabled = 0;
          }

        }, error => {

        }
      );
  }

  getAllNotification(isAppend: boolean = false) {
    if (this.loading || (isAppend && this.isLastPage)) return;

    this.loading = true;
    const size = 10;

    let obs: Observable<any>;
    if (this.selectedFilter === 'mentions') {
      const search = "a.type:'*mention*'";
      obs = this.notificationService.searchNotificationAdvance(search, this.page, size, this.sortParam, "");
    } else if (this.selectedFilter === 'Duplicate Lead') {
      const search = "a.type:'*Duplicate Lead*'";
      obs = this.notificationService.searchNotificationAdvance(search, this.page, size, this.sortParam, "");
    } else {
      obs = this.notificationService.getAllNotificationNew(this.page, size, this.sortParam);
    }

    obs.subscribe(
      res => {
        const newData = res['content'] || [];

        if (isAppend) {
          this.notificationList = [...this.notificationList, ...newData];
        } else {
          this.notificationList = newData;
        }

        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
        this.isLastPage = res['last'];
        this.loading = false;
        if (!isAppend) {
          this.updateUnreadCount();
        } else {
          this._changeDetectorRef.detectChanges();
        }
      },
      error => {
        this.loading = false;
      }
    )
  }

  updateUnreadCount(): void {
    let search = "a.isRead:0";
    if (this.selectedFilter === 'mentions') {
      search = "a.isRead:0 AND a.type:'*mention*'";
    } else if (this.selectedFilter === 'Duplicate Lead') {
      search = "a.isRead:0 AND a.type:'*Duplicate Lead*'";
    }

    this.notificationService.searchNotificationAdvance(search, 0, 1, 'notificationId,desc', "").subscribe({
      next: (res: any) => {
        if (res && res.totalElements !== undefined) {
          this.unreadCount = res.totalElements;
          this._changeDetectorRef.detectChanges();
        }
      },
      error: (err: any) => {
        console.error('Error fetching unread count from server', err);
      }
    });
  }

  onScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) {
      if (!this.isLastPage && !this.loading) {
        this.page++;
        this.getAllNotification(true);
      }
    }
  }

  setFilter(filter: string) {
    if (this.selectedFilter === filter) return;
    this.selectedFilter = filter;
    this.page = 0;
    this.notificationList = [];
    this.isLastPage = false;
    this.getAllNotification();
  }

  toggleRead(notification: any) {
    const originalState = notification.isRead;
    const isNowRead = notification.isRead === 0;
    notification.isRead = isNowRead ? 1 : 0;

    // Optimistically update count
    if (isNowRead) {
      this.unreadCount = Math.max(0, this.unreadCount - 1);
    } else {
      this.unreadCount = this.unreadCount + 1;
    }
    this._changeDetectorRef.detectChanges();

    this.notificationService.addOrEditNotification(notification).subscribe({
      next: () => {
        this.updateUnreadCount();
      },
      error: (err) => {
        console.error('Failed to update notification:', err);
        notification.isRead = originalState;
        this.updateUnreadCount();
        this.snackBar.open('Failed to update notification status', 'Dismiss', {
          duration: 3000
        });
      }
    });
  }

  addContact() {
    this.router.navigate(['/lead']);
  }

  extractNotificationLeadInfo(data: any): { leadId: string | null; setId: string | null } {
    if (!data) return { leadId: null, setId: null };

    let leadId: string | null = null;
    let setId: string | null = null;

    if (typeof data === 'number' || (typeof data === 'string' && /^\d+$/.test(data.trim()))) {
      return { leadId: String(data).trim(), setId: null };
    }

    if (typeof data === 'object') {
      leadId = data.leadId || data.id || (Array.isArray(data.leadIds) ? data.leadIds[0] : null);
      setId = data.setId || null;
      return { leadId: leadId ? String(leadId) : null, setId: setId ? String(setId) : null };
    }

    if (typeof data === 'string') {
      const trimmed = data.trim();
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (parsed) {
            leadId = parsed.leadId || parsed.id || (Array.isArray(parsed.leadIds) ? parsed.leadIds[0] : null);
            setId = parsed.setId || null;
            if (leadId) {
              return { leadId: String(leadId), setId: setId ? String(setId) : null };
            }
          }
        } catch (e) { }
      }

      const leadIdMatch = trimmed.match(/leadId[=\s:]+([0-9]+)/i) || trimmed.match(/leadIds[=\s:]+\[([0-9]+)/i);
      if (leadIdMatch) {
        leadId = leadIdMatch[1];
      }

      const setIdMatch = trimmed.match(/setId[=\s:]+([0-9]+)/i);
      if (setIdMatch) {
        setId = setIdMatch[1];
      }
    }

    return { leadId: leadId ? String(leadId) : null, setId: setId ? String(setId) : null };
  }

  navigation(notification) {
    if (this.notificationTrigger) {
      this.notificationTrigger.closeMenu();
    }
    if (!notification) {
      return;
    }
    if (notification.isRead === 0) {
      notification.isRead = 1;
      // Optimistically update count
      this.unreadCount = Math.max(0, this.unreadCount - 1);
      this._changeDetectorRef.detectChanges();

      this.notificationService.addOrEditNotification(notification).subscribe({
        next: () => {
          this.updateUnreadCount();
        }
      });
    }
    if (notification) {
      const typeLower = (notification.type || '').toLowerCase();
      const messageLower = (notification.message || '').toLowerCase();

      if (typeLower.includes('bulk lead transfer') || messageLower.includes('bulk lead transfer')) {
        this.onClickOutside();
        return;
      }

      const { leadId, setId } = this.extractNotificationLeadInfo(notification.data);

      if (typeLower === 'mention' || typeLower === 'duplicate lead' || typeLower === 'lead transfer' || typeLower.includes('lead') || typeLower.includes('transfer')) {
        if (leadId && /^\d+$/.test(leadId)) {
          if (setId) {
            this.router.navigate([`add-edit-leadDetail/${leadId}/${setId}`]);
          } else {
            this.router.navigate([`leadDetail/${leadId}`]);
          }
        }
      }
    }
    this.onClickOutside();
  }

  addAccount() {
    this.router.navigate(['/companies']);
  }

  addDeals() {
    this.router.navigate(['/deals']);
  }

  explore() {
    this.router.navigate(['/marketplace']);
  }

  getAccountData() {
    this.accountService.getAllAccountsBYtenant().subscribe(
      (data: any) => {


        this.accountList = data;

        if (this.accountList.length > 0) {
          const acc = this.accountList[0];
          const message = this.subscriptionsService.getSubscriptionMessage(acc);
          this.subscriptionsService.updateTrialExpiredMessage(message);

          if (this.accountList[0].accountName == 'calsoft') {
            localStorage.setItem('displayedTour', 'true');
          } else {
            localStorage.setItem('displayedTour', 'false');
          }

          localStorage.setItem('accountPlan', this.accountList[0].plan);

          localStorage.setItem('accountName', this.accountList[0].accountName);

          localStorage.setItem('businessDetailProvide', this.accountList[0].businessDetailProvide);

          if (this.accountList[0].plan != 5 && this.accountList[0].accountName != 1) {
            if (this.accountList[0].businessDetailProvide != "1") {
              this.openIntegrationWhatsapp();
            }
          }


          localStorage.setItem('businessType', this.accountList[0].businessType);

          let user = this.accountList[0].totalUserSubscrition;

          let renewalDate = this.accountList[0].renewalDate;

          let today = new Date();


          if (this.accountList[0].freeTrail == 1) {

            this.text = 'Upgrade'

            if (this.showadduser == true) {
              this.displayRenewButton = true;
            }
            this.enableAddUser = true;

          } else {

            this.text = 'Add New User';
            if (!renewalDate) {
              renewalDate = today.toISOString();
            }

            let renewalDateObj = new Date(renewalDate);

            let diffTime = renewalDateObj.getTime() - today.getTime();

            let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays > 7) {

              this.enableAddUser = true;


            } else {
              this.enableAddUser = false;
            }
            if (this.showadduser == true) {
              this.displayRenewButton = true;
            }
          }

          this._changeDetectorRef.detectChanges();

        }

      }

    )
  }

  gotogrid() {
    this.router.navigate(['/adminNotification']);
  }
  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.NOTIFICATION)
      .subscribe((data: any) => {
        if (data.read) {

          this.read = data.read;

        }
      });
  }


  openIntegrationWhatsapp(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.panelClass = 'whatsapp-integration-dialog-container';


    dialogConfig.width = '900px';
    dialogConfig.maxWidth = '95vw';

    const dialogRef = this.dialog.open(WhatappIntegrationPopupComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      const userCreated = localStorage.getItem('userCreated');
      if (userCreated == '1' || res === true) {
        this.initTourState();
      }
    });
  }

  private initTourState(): void {
    this.tourApi.startTour().subscribe({
      next: (res) => {
        this.tourEnabled = res.tourEnabled;
        console.log("tourEnabled", this.tourEnabled);

        if (res.tourEnabled) {
          this.tourService.startTour();
        }
      },
      error: () => { this.tourEnabled = false; }
    });
  }

  signOut(): void {
    this.router.navigate(['/sign-out']);
    this.onClickOutside();
  }

  onClickOutside() {
    this.isOpen = false;
  }


  profile() {
    this.router.navigate([`/userRole/profile`])
    this.onClickOutside();
  }

  openTwoFactorAuth(): void {
    this.router.navigate(['/two_factor_auth']);
    this.onClickOutside();
  }

  billing(): void {
    this.router.navigate(['/subscription/manage']);
    this.onClickOutside();
  }

  helpDesk(): void {
    this.router.navigate(['/help']);
    this.onClickOutside();
  }

  private loadTwoFactorStatus(): void {
    this.loginService.getTwoFactorStatus().subscribe(
      (response: any) => {
        if (response && response['status_code'] === 'AST-200' && response['data']) {
          this.twoFactorEnabled = !!response['data'].twoFactorEnabled;
          const encryptedSigninDetails = localStorage.getItem('signinDetails');
          if (encryptedSigninDetails) {
            try {
              const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
              const signinDetails = JSON.parse(decrypted);
              signinDetails.twoFactorEnabled = this.twoFactorEnabled;
              localStorage.setItem('signinDetails', this.ecryptService.encryptionAES(JSON.stringify(signinDetails)));
            } catch (error) {
              console.error('Error updating two-factor state in signinDetails:', error);
            }
          }
          this._changeDetectorRef.markForCheck();
        }
      },
      () => {
        // Keep last known state if status fetch fails.
      }
    );
  }

  startTour(): void {
    this.onClickOutside();
    this.tourService.startTour();
  }

  toggleWhatsNew(): void {
    this.showWhatsNew = !this.showWhatsNew;
    if (!this.showWhatsNew) {
      this.closeWhatsNewSearch();
    }
  }

  closeWhatsNew(): void {
    this.showWhatsNew = false;
    this.closeWhatsNewSearch();
  }

  toggleWhatsNewSearch(): void {
    this.isSearchingWhatsNew = !this.isSearchingWhatsNew;
    if (!this.isSearchingWhatsNew) {
      this.whatsNewSearchQuery = '';
      this.loadWhatsNew();
    }
  }

  closeWhatsNewSearch(): void {
    this.isSearchingWhatsNew = false;
    this.whatsNewSearchQuery = '';
    this.loadWhatsNew();
  }

  loadWhatsNew(): void {
    this.whatsNewService.getAllWhatsNew(0, 10, 'whatsNewId,desc').subscribe((res: any) => {
      this.whatsNewData = res.content || [];
    });
  }

  onWhatsNewSearch(event: any): void {
    const query = event.target.value;
    this.whatsNewSearchQuery = query;
    if (query && query.trim().length > 0) {
      let searchTerm = "title:'" + '*' + query.trim() + '*' + "'";
      this.whatsNewService.whatsNewSearch(searchTerm, 0, 10, 'whatsNewId,desc').subscribe((res: any) => {
        this.whatsNewData = res.content || [];
      });
    } else {
      this.loadWhatsNew();
    }
  }

  appDownload() {
    window.open(
      'https://www.flowzo.ai/download-mobile-app',
      '_blank'
    );
    this.onClickOutside();
  }

  safeDecryptAndParse(encryptedText: string | null): any {
    if (!encryptedText) {
      return null;
    }
    try {
      const decrypted = this.ecryptService.decryptionAES(encryptedText);
      if (!decrypted || decrypted === '') {
        return null;
      }
      return JSON.parse(decrypted);
    } catch (error) {
      console.error('Failed to decrypt or parse trial message:', error);
      return null;
    }
  }

  referAndEarn() {
    this.router.navigate(['/refer-earn']);
    this.onClickOutside();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  gotoPos() {
    this.router.navigate(['/pos/sale']);
  }

}
